import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS, SERVICES_TYPE } from "@constants"


export default function AppAcrissGroupsAutocomplete({ ...props }) {
	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false}
		multiple
		label="Acriss Group"
		placeholder="No grouping"
		urlAjax={`${BACKEND_APIS.CRUD}/user/${SERVICES_TYPE.ACRISS_GROUP}?selectorFormat=true`}
		{...props}
	/>
}
